<script setup lang="ts">
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()

const current = ref(route.name)

watch(route, () => {
  current.value = route.name
})

const menuList = {
  CustomerAdd: { title: '고객 추가', label: '고객 추가' },
  CustomerManage: { title: '고객 관리', label: '고객 관리' },
}
</script>

<template>
  <header
    class="page-header"
    :class="current.toLowerCase()"
    v-if="current === 'CustomerManage'"
  >
    <h2 class="tit-h2">
      {{ menuList[current]?.title }}
    </h2>
    <div class="btn-group">
      <template v-if="current === 'CustomerManage'">
        <router-link :to="{name: 'CustomerAdd'}">
          <el-button 
            type="primary"
            size="large"
          >
            {{ menuList['CustomerAdd'].label }}
          </el-button>
        </router-link>
      </template>
    </div>
  </header>
  <router-view />
</template>